import { jwtDecode } from "jwt-decode";
import { ERole } from "models/account";

export const isAdminOnly = (): boolean => {
  const payload: any = jwtDecode(localStorage.getItem("token")!);
  return [ERole.ADMIN].includes(payload.role);
};

export const isAdmin = (): boolean => {
  const payload: any = jwtDecode(localStorage.getItem("token")!);
  return [ERole.ADMIN, ERole.SUPER_ADMIN].includes(payload.role);
};

export const isNotPolice = (): boolean => {
  const payload: any = jwtDecode(localStorage.getItem("token")!);
  return ERole.POLICE !== payload.role;
};

export const isCasher = (): boolean => {
  const payload: any = jwtDecode(localStorage.getItem("token")!);
  return [ERole.ADMIN, ERole.SUPER_ADMIN, ERole.CASHER].includes(payload.role);
};

export const isDispatcher = (): boolean => {
  const payload: any = jwtDecode(localStorage.getItem("token")!);
  return [ERole.ADMIN, ERole.SUPER_ADMIN, ERole.DISPATCH].includes(
    payload.role
  );
};

export const isSuperAdmin = (): boolean => {
  const payload: any = jwtDecode(localStorage.getItem("token")!);
  return ERole.SUPER_ADMIN === payload.role;
};

export const isCasherOrSuperAdmin = (): boolean => {
  const payload: any = jwtDecode(localStorage.getItem("token")!);
  return ERole.SUPER_ADMIN === payload.role || ERole.CASHER === payload.role;
};

export const getRole = (): ERole | null => {
  try {
    const payload: any = jwtDecode(localStorage.getItem("token")!);
    return payload.role;
  } catch (error) {
    return null;
  }
};
